///<reference path="../short-cuts/models/maintenance-short-cuts.controller.ts"/>

module Meevo.Components.CommonClasses {

    import IShortCutGroup = Meevo.Components.ShortCuts.IShortCutGroup;
    import ICommonContext = Meevo.Components.CommonClasses.ICommonContext;
    import MaintenanceShortCutsController = Meevo.Components.ShortCuts.MaintenanceShortCutsController;

    export abstract class CommonControllerBase extends MaintenanceShortCutsController<ICommonSection, ICommonContext> implements Meevo.Components.CommonClasses.ICommonController {

        protected context: ICommonContext;
        protected meevoSecurityKeys = Meevo.Components.Common.SecurityKeys;

        /**
        * The state/route/context name associated with this controller
        * It is derived from the current state that is active when the controller is instantiated.
        * If the child class doesn't supply $state to this base constructor, then this is never populated.
        */
        protected associatedStateName: string = '';

        protected shortCutGroup: IShortCutGroup | { [key: number]: IShortCutGroup };

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.CommonClasses.ICommonDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected $scope: angular.IScope,
            protected contextParams: IContextParams,
            protected $state: any,
            protected $rootScope: angular.IRootScopeService,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService) {
            super($scope, $state, shortCutsService);
            let vm = this;

            /********************************************************************************
            * State/route/context monitoring
            * 1. Get the state/route name associated with this controller
            * 2. Hook the state change success listener to the handlers
            ********************************************************************************/
            // If $state is passed in by the child, we assign a local member to hold the state name.
            // The $state.current property holds the current state name that is active as this constructor runs
            // so we take that to be the state associated with this controller for active/inactive purposes.
            if (!_.isEmpty($state)) {
                this.associatedStateName = $state.current.name;
            }
            // Hook the listener to $rootScope, if it is available
            if (!_.isEmpty($scope)) {
                $scope.$on('$stateChangeSuccess',
                    (event, toState, toParams, fromState, fromParams) => {
                        if (toState.name === this.associatedStateName) {
                            this.onRouteActive();
                            //  Prevent Access To SelectedSection If Unauthorized User Logs In Thru MeevoLockout Feature
                            let hasSelectedSection = (<any>this.context || {}).selectedSection || null;
                            let hasAccessToSelectedSection = !!hasSelectedSection && (<any>this.context).securityChecker.hasSecurity(this.context.selectedSection.sectionSecurityKey);
                            if (this.context && !hasAccessToSelectedSection) {
                                if ((<any>this.context).navigationBlocked) {
                                    this.modalService.alert('Oops ... you are not supposed to be here. Please click cancel to discard changes and move to another screen')
                                } else {
                                    let index = _.findIndex(this.context.sections, (s: any) => s.sectionSecurityKey ? (<any>this.context).securityChecker.hasSecurity(s.sectionSecurityKey) : true);
                                    this.context.selectedSection = this.context.sections[index] || this.context.selectedSection
                                }
                            }
                        } else if (fromState.name === this.associatedStateName) {
                            this.onRouteInactive();
                        }
                    });
            }
            // Run onRouteActive here since this also counts as entering this state (and the stateChangeSuccess message has already happened for this first load
            this.onRouteActive();
        }

        /**
        * Function which handles creation of the context for the matainenance form,
        * activation, and additional initialization.
        * @return {}
        */
        public createContext(): void {
            this.context.closeCallback = this.processCallback;
        };

        /**
        * Handles processing a call back if one was supplied in the contextParams.
        * this will enable other areas to navigate to the client, and then redirect
        * back to themselves upon an event (i.e. postAdd, postUpdate, postCancel...)
        * @return{}
        */
        private processCallback(model: any, executeCallback: boolean): void {
            var cb = Model.Guard.isSomething(this.contextParams) ? this.contextParams.params : null;  //this may be overwritten during closecontext, so cache it temporarily here.
            if (cb) {
                this.$rootScope.$broadcast("closeContext", this.$state.current, this.contextParams.params.callbackState);
                if (executeCallback && cb.callback) {
                    cb.callback(model);
                }
            }
        }

        /**
        * Runs when this route becomes active, either due to initial creation
        * or by being navigated to as a sticky state
        */
        onRouteActive() {
        }

        /**
        * Runs when the route becomes inactive (i.e. another route is navigated to
        * from this one.
        */
        onRouteInactive() {
        }

        getContext(): Meevo.Components.CommonClasses.ICommonContext {
            return this.context;
        }
    }

}